import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHintSelectRoleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 20,
	viewBox: "0 0 17 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_13027_10426)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.5 1L11.5 1C13.7091 1 15.5 2.79086 15.5 5L15.5 15C15.5 17.2091 13.7091 19 11.5 19L5.5 19C3.29086 19 1.5 17.2091 1.5 15L1.5 5C1.5 2.79086 3.29086 0.999999 5.5 1Z",
				stroke: "#2C70EC",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.77393 7.24127C5.77393 4.21686 10.5263 4.21686 10.5263 7.24127C10.5263 9.40139 8.36619 8.96924 8.36619 11.5615",
				stroke: "#2C70EC",
				strokeWidth: 1.5,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 8.48828,
				cy: 14.2771,
				r: .75,
				fill: "#2C70EC"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13027_10426",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 20,
			fill: "white",
			transform: "translate(0.5)"
		})
	}) })]
});
export default SvgHintSelectRoleIcon;
